import React, { Component } from 'react';
import moment from 'moment';
import { ButtonTheme, Placement } from '@philips-internal/oswald-ui-constants';
import { classNames, trigger } from '@philips-internal/oswald-ui-utils';
import './pseudonym-appointment-suggestion-resume-card.css';
import { ReactComponent as ClockIcon } from '../../../assets/images/icons/DLS_Clock_16.svg';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { Button } from '@philips-internal/oswald-ui-components';
class PseudonymAppointmentSuggestionResumeCard extends Component {
    getClassName(suffix, addMain = false) {
        const CLASS_NAME_PREFIX = 'c-pseudonym-appointment-suggestion-resume-card';
        return classNames({
            [CLASS_NAME_PREFIX]: addMain,
            [`${CLASS_NAME_PREFIX}__${suffix}`]: Boolean(suffix),
        });
    }
    formatItemMessage(startDate) {
        const formattedStart = moment(startDate).format('HH:mm');
        return formattedStart;
    }
    renderAppointmentEvent(event) {
        const { name, startDate } = event;
        return (React.createElement("div", { className: this.getClassName('event-item'), key: name }, this.formatItemMessage(startDate)));
    }
    renderAppointmentButtonDetails() {
        return (React.createElement("div", { className: this.getClassName('bottom-content') },
            React.createElement(Button, { value: MessageService.translate('patient.on.my.way'), theme: ButtonTheme.QUIET_EMPHASIS, iconPlacement: Placement.LEFT, className: this.getClassName('button-details') })));
    }
    render() {
        const { consultationLocation, events, numberOfSuggestions, onClick } = this.props;
        const hasEvents = events?.length > 0;
        return (React.createElement("div", { className: this.getClassName('vertical', true), onClick: trigger(onClick) },
            React.createElement("div", { className: this.getClassName('parameter-info') },
                React.createElement("div", { className: this.getClassName('number-suggestions') }, `${MessageService.translate(numberOfSuggestions)} ${MessageService.translate('tws.appointment-suggestion.suggestions')}`)),
            React.createElement("div", { className: this.getClassName('details') },
                React.createElement("div", { className: this.getClassName('details-columm') },
                    React.createElement("div", { className: this.getClassName('title') }, MessageService.translate(consultationLocation))),
                React.createElement("div", { className: this.getClassName('details-columm') },
                    React.createElement("div", { className: this.getClassName('schedule-time') },
                        React.createElement(ClockIcon, null),
                        hasEvents && this.renderAppointmentEvent(events[0])))),
            React.createElement("div", { className: this.getClassName('separator') }),
            React.createElement("div", { className: this.getClassName('bottom-content') },
                React.createElement(Button, { value: MessageService.translate('tws.file-uploader.preview'), theme: ButtonTheme.QUIET_EMPHASIS, iconPlacement: Placement.LEFT, className: this.getClassName('button-details') }))));
    }
}
export default PseudonymAppointmentSuggestionResumeCard;
//# sourceMappingURL=pseudonym-appointment-suggestion-resume-card.js.map